import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
} from '@mui/material';
import { UploadFile as UploadFileIcon } from '@mui/icons-material';

function AddFileDialog({ open, onClose, formData, formErrors, isUploading, onChange, onSubmit }) {
  const handleFileInputChange = (event) => {
    onChange('file')(event);
    if (event?.target) {
      event.target.value = '';
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <UploadFileIcon />
        Upload Document
      </DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 1 }}>
          <TextField
            fullWidth
            label="Document Name"
            value={formData.name}
            onChange={onChange('name')}
            placeholder="Enter document name"
            error={!!formErrors.name}
            helperText={formErrors.name}
            sx={{ mb: 3 }}
            disabled={!!formData.fromTemplateKey}
          />
          <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', gap: 1 }}>
            <Button
              variant="outlined"
              startIcon={<UploadFileIcon />}
              component="label"
              sx={{ alignSelf: 'flex-start' }}
            >
              {formData.file ? 'Change File' : 'Select File'}
              <input
                hidden
                type="file"
                accept=".pdf,.doc,.docx,.txt,.md,.rtf"
                onChange={handleFileInputChange}
              />
            </Button>
            {formData.file && (
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {formData.file.name}
              </Typography>
            )}
            {formErrors.file && (
              <Typography variant="caption" sx={{ color: 'error.main' }}>
                {formErrors.file}
              </Typography>
            )}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} color="inherit">
          Cancel
        </Button>
        <Button
          onClick={onSubmit}
          variant="contained"
          disabled={isUploading}
          sx={{
            backgroundColor: '#374151',
            color: '#ffffff',
            '&:hover': {
              backgroundColor: '#1f2937'
            }
          }}
        >
          {isUploading ? 'Uploading...' : 'Upload Document'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddFileDialog;

